import { useEffect } from 'react';

import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/**
 * The one error card (audit C4 — this exact shape was inlined ~a dozen times).
 * Destructive-tinted border, a title, and apologize-free actionable copy. When
 * an `error` is passed it's logged to the console so the detail is one keystroke
 * away without cluttering the UI.
 */
export function ErrorCard({
  title,
  description = 'Something went wrong. Try refreshing. Details in the browser console.',
  error,
  className,
}: {
  title: string;
  description?: string;
  error?: unknown;
  className?: string;
}) {
  // Log from an effect keyed on (title, error) so re-renders / StrictMode's
  // double-invoke don't duplicate the message.
  useEffect(() => {
    if (error !== undefined) console.error(`${title}:`, error);
  }, [title, error]);

  return (
    <Card className={cn('max-w-xl border-destructive/30', className)}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
    </Card>
  );
}
